import React from 'react';
import Signup from '../components/Signup';

const UserSignup: React.FC = () => {
  return (
    <div>
        <Signup />
    </div>
  );
};

export default UserSignup;